export const inputGroupRequiredComponentModule = angular
  .module('Q.components.forms.input-group-required', [])

  .directive('inputGroupRequired', function () {
    return {
      restrict: 'A',
      link(scope, elem) {
        scope.$watch(
          () => !!elem[0].querySelector('.ng-invalid-required'),
          (invalid) => {
            elem.toggleClass('ng-invalid-required', invalid);
          },
        );
      },
    };
  });
